import React from "react";

const TextArea = ({ label, ...rest }) => {
  return (
    <div>
      <label>{label}</label>
      <textarea rows="10" cols="50" {...rest}></textarea>
    </div>
  );
};

export default TextArea;
